export enum SearchCategory {
  Shipments = 'shipments',
  Messages = 'messages',
}

export const SEARCH_CATEGORIES = Object.keys(SearchCategory).map((category) => SearchCategory[category])
